import React from 'react';
import { stack as Menu } from 'react-burger-menu'
// import Menu from 'react-burger-menu/lib/menus/slide'  //  limits size of webpack bundle
                                                      //  https://github.com/negomi/react-burger-menu

export default class SideMenu extends React.Component {
  state = {
    menuOpen: false
  };
  handleOnClick = (e) => {
    if(e.target.id === "10") {
      window.location.href = "https://www.avfx.com/";
    } else {
      this.props.handleSetCurrentPage(parseInt(e.target.id, 10));
      this.closeMenu();
    }
  }
  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})
  }
  closeMenu () {
    this.setState({menuOpen: false})
  }
  showSettings (event) {
    event.preventDefault();
  }
  render () {
    return (
      <Menu
        width={440}
        isOpen={this.state.menuOpen}
        onStateChange={(state) => this.handleStateChange(state)}
        customCrossIcon={false}
        customBurgerIcon={<img src="./ui-graphics/hamburger-menu.svg" />}
      >
        <h1 className="menu-header">Ways to Wow</h1>
        <a id="0" className="menu-item" onClick={this.handleOnClick}>{"1 - " + this.props.titles[0]}</a>
        <a id="1" className="menu-item" onClick={this.handleOnClick}>{"2 - " + this.props.titles[1]}</a>
        <a id="2" className="menu-item" onClick={this.handleOnClick}>{"3 - " + this.props.titles[2]}</a>
        <a id="3" className="menu-item" onClick={this.handleOnClick}>{"4 - " + this.props.titles[3]}</a>
        <a id="4" className="menu-item" onClick={this.handleOnClick}>{"5 - " + this.props.titles[4]}</a>
        <a id="5" className="menu-item" onClick={this.handleOnClick}>{"6 - " + this.props.titles[5]}</a>
        <a id="6" className="menu-item" onClick={this.handleOnClick}>{"7 - " + this.props.titles[6]}</a>
        <a id="7" className="menu-item" onClick={this.handleOnClick}>{"8 - " + this.props.titles[7]}</a>
        <a id="8" className="menu-item" onClick={this.handleOnClick}>{"9 - " + this.props.titles[8]}</a>
        <a id="9" className="menu-item" onClick={this.handleOnClick}>{"10 - " + this.props.titles[9]}</a>
        <a id="10" className="menu-item" onClick={this.handleOnClick}>Learn More</a>
      </Menu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js